<template>
    <div class="container">
        <div class="search-panel__inner">
            <div class="row">
                <div class="col-lg-3 col-xxl-2">
                    <SideView
                        @scrollToMainView="scrollToMainView"
                    />
                </div>
                <div class="col-lg-9 col-xxl-10">
                    <CatchPending ref="mainView">
                        <MainView
                          @pageChanged="scrollToMainView"
                        />
                    </CatchPending>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {useStore} from 'vuex'
import {computed, onMounted, watchEffect, ref} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import SideView from "./components/View/SideView";
import MainView from "./components/View/MainView";
import CatchPending from "./components/Status/CatchPending";

export default {
    name: 'App',
    components: {
        MainView,
        SideView,
        CatchPending,
    },
    methods: {
        scrollToMainView() {
            setTimeout(() => {
                this.$refs.mainView.$el.scrollIntoView({
                    behavior: 'smooth'
                });
            }, 50)
        }
    },
    setup() {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();
        const mainView = ref();
        const fields = document.querySelectorAll('[data-search-container]');

        useRouter().isReady().then(() => {
            const urlObject = {...route.params, ...route.query}
            store.dispatch('initialize', {...urlObject});

            panelChanged();
        });

        onMounted(() => {
            window.onpopstate = () => {
                const urlObject = {...route.params, ...route.query}
                store.dispatch('setHistoryState', urlObject)
            }
        });

        const doSearch = (e) => {
            store.dispatch('updateText', e.target.value);
        };

        const panelChanged = (e) => {
            const panelOpen = document.querySelector('[data-njam-search]').classList.contains('search-panel--show');
            store.dispatch('setPanelOpen', panelOpen);
            store.dispatch('setShouldChangeUrl', panelOpen);

            if(e && !e.detail.opened) router.push((new URL(placeholders.router.request)).pathname);
        }

        fields.forEach(field => {
            field.addEventListener('keyup', doSearch);
        });

        // add the state of the panel to the store
        document.querySelector('[data-njam-search]').addEventListener('toggle', panelChanged);

        return {
            fetchState: computed(() => store.state.fetchState),
            mainView
        }
    }
}
</script>